import React, { ReactNode } from "react";
import { useTranslation } from 'react-i18next';

// MUI
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


type IPublicIzletInfoCardProps = {
  title: string;
  content?: ReactNode;
  width?: number;
};

const PublicIzletiInfoSection = (props: IPublicIzletInfoCardProps) => {
  const { title, content, width } = props;
  const { t } = useTranslation();

  const lg = width === 3 ? 9 : width === 2 ? 6 : 3;
  const md = width === 3 ? 12 : width === 2 ? 8 :4;
  const xs = width === 3 ? 12 : width === 2 ? 12 : 6;

  return content ? (
    <Grid size={{ lg, md, xs }} display='flex' flexDirection='column'>
      <Box width='100%'>
        <Typography variant="body1" color='primary' fontWeight='500'>
          {t(title)}
        </Typography>
      </Box>
      <Box width='100%' flexGrow='1'>
        {typeof content === 'string' ? <Typography variant="body1">{content}</Typography> : <>{content}</>}
      </Box>
    </Grid>
  ) : null;
};

export default PublicIzletiInfoSection;
